import { Component, Vue } from 'vue-property-decorator';

import { format } from 'date-fns';

@Component({
    metaInfo() {
        return {
            title: (this as any).document ? (this as any).document.data.title[0].text : 'Loading',
        };
    },
})
export default class Item extends Vue {
    document: any = false;

    get date() {
        if (this.document) {
            return format(this.document.data.date, 'D MMMM YYYY');
        } else {
            return null;
        }
    }

    mounted() {
        this.getData();
    }

    async getData() {
        this.document = await this.$prismic.client.getByUID(this.$route.meta.type, this.$route.params.uid);
    }
}
